import { type FC, Fragment } from "react";

import { BasicLink } from "./basic_link";

export type HiddenPagesOrigin = {
  to: string;
  label: string;
};

// One quiet line above a document's page panes, explaining why its page
// numbering skips: those pages were folded into copies elsewhere. It sits
// full width rather than in the thumbnail rail, which is too narrow to hold a
// sentence. `summary` and each `label` arrive built by the server — nothing
// here composes copy.
export const HiddenPagesNotice: FC<{
  summary: string;
  origins: HiddenPagesOrigin[];
}> = ({ summary, origins }) => (
  <p className="px-6 pb-3 text-xs leading-relaxed text-slate-500">
    {summary}
    {origins.length > 0 && ": "}
    {origins.map((origin, index) => (
      <Fragment key={origin.to}>
        {index > 0 && ", "}
        <BasicLink to={origin.to}>{origin.label}</BasicLink>
      </Fragment>
    ))}
  </p>
);

HiddenPagesNotice.displayName = "HiddenPagesNotice";
